export var Variant;
(function (Variant) {
    Variant["error"] = "error";
    Variant["success"] = "success";
    Variant["loading"] = "loading";
})(Variant || (Variant = {}));
export var LabelPosition;
(function (LabelPosition) {
    LabelPosition["right"] = "right";
    LabelPosition["bottom"] = "bottom";
    LabelPosition["top_floating"] = "top_floating";
    LabelPosition["bottom_floating"] = "bottom_floating";
})(LabelPosition || (LabelPosition = {}));
